<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="tip-header-class">
        <span class="tip-header-font ml-3">Third Party Integration</span>
      </div>
      <div class="tip-below-card mt-2">
        <div
          v-for="category in thirdParties"
          :key="category.category"
          class="mb-5"
        >
          <div class="tip-email-integration-font">
            {{ category.categoryName }}
            <span class="tip-number-font ml-1"
              >({{ category.thirdParty.length }})</span
            >
          </div>
          <div class="d-flex flex-wrap">
            <template v-if="category.category != 3">
              <div
                v-for="party in category.thirdParty"
                :key="party.thirdPartyID"
                class="tip-card p-3 mt-3 mr-3"
              >
                <div class="d-flex">
                  <img :src="party.imagePath" alt="" width="50" height="50" />
                  <div class="d-flex flex-column ml-4">
                    <div class="tip-gmail-font">{{ party.name }}</div>
                    <div class="tip-learn-more" @click="openInNew(party.link)">
                      Learn More
                    </div>
                  </div>
                </div>
                <div class="mt-4 tip-email-service tip-description">
                  {{ party.description }}
                </div>
                <hr />
                <!-- <div class="tip-line mt-5 ml-4"></div> -->
                <div
                  @click="
                    roles.includes('PUT_THIRD_PARTY') ? setParty(party) : ''
                  "
                  :class="
                    !roles.includes('PUT_THIRD_PARTY') && 'disabled-kanban-img'
                  "
                  class="text-center mt-2 tip-connect-gmail-font pointer"
                >
                  {{ party.enabled ? "Enabled" : "Disabled" }}
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="party in category.thirdParty"
                :key="party.thirdPartyID"
                class="mr-3 mt-3 tip-card-cont"
              >
                <div
                  class="
                    tip-codility
                    d-flex
                    justify-content-center
                    align-items-center
                    text-center
                    h-33
                  "
                >
                  <img :src="party.imagePath" alt="" height="100" width="100" />
                </div>

                <div class="tip-card position-relative h-67">
                  <div class="p-3">
                    <div class="tip-gmail-font">{{ party.name }}</div>
                    <!-- <div class="tip-learn-more" @click="openInNew(party.link)">
                    Learn More
                  </div> -->
                    <div class="mt-4 tip-email-service">
                      {{ party.description }}
                    </div>
                  </div>
                  <div
                    class="
                      tip-card-footer
                      d-flex
                      justify-content-center
                      align-items-center
                      flex-column
                      w-100
                    "
                  >
                    <div class="tip-line"></div>
                    <div
                      @click="
                        roles.includes('PUT_THIRD_PARTY') ? setParty(party) : ''
                      "
                      :class="
                        !roles.includes('PUT_THIRD_PARTY') &&
                        'disabled-kanban-img'
                      "
                      class="tip-connect-gmail-font pointer text-center mt-2"
                    >
                      {{ party.enabled ? "Enabled" : "Disabled" }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <ConfirmModal
          @confirmButton="closeModal"
          @handle-submit="changeParty()"
          :button="button"
          :header="'Confirmation'"
          :msg="`Are you sure you want to ${action} ${selParty.name}?`"
          :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAllThirdParties,
  enableDisableThirdParty,
} from "../../utils/apiFunctions";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";
import { mapGetters } from "vuex";
export default {
  name: "ThirdParty",
  data() {
    return {
      hai: "",
      thirdParties: [],
      LoaderStatus: false,
      selParty: {},
      showModal: false,
      action: null,
      button: null,
    };
  },
  components: { Spinner, ConfirmModal },
  mixins: [toast],
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("confirmationmsg");
    },
    setParty(party) {
      this.action = !party.enabled ? "enable" : "disable";
      this.button = !party.enabled ? "Enable" : "Disable";
      this.selParty = party;
      this.$bvModal.show("confirmationmsg");
    },
    openInNew(link) {
      window.open(link);
    },
    async changeParty() {
      this.LoaderStatus = true;
      try {
        let payload = {
          thirdPartyID: this.selParty.thirdPartyID,
          enabled: !this.selParty.enabled,
        };
        const res = await enableDisableThirdParty(payload);

        if (res.status == 200) {
          let value = !this.selParty.enabled ? "enabled" : "disabled";
          let text = `${this.selParty.name} have been scuccessfully ${value}`;
          this.dynamicToast("success", `Successfully ${value}`, text);
          this.getThirdParties();
        } else {
          this.errorModal("Something went wrong");
        }
        this.closeModal();
        this.LoaderStatus = false;
      } catch (error) {
        this.closeModal();
        this.errorModal("Something went wrong");
        this.LoaderStatus = false;
      }
    },
    async getThirdParties() {
      this.LoaderStatus = true;
      try {
        let params = {
          sortBy: "name",
          order: false,
          configure: true,
        };
        const res = await getAllThirdParties(params);

        if (res.status == 200) {
          this.thirdParties = res.data.data;
        }
        this.LoaderStatus = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getThirdParties();
  },
};
</script>
<style>
.tip-description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
  /* margin: 1rem; */
}
</style>
